// Formats a currency input to 2 decimal precision
// TODO: Fix jerky input when typing in middle or before $

export const CurrencyDirective = {

  bind (el) {
    // Set initial currency value
    const strippedValues = el.value.replace(/([^0-9.])+/g, '').split('.')
    const dollars = strippedValues[0].length > 1 && strippedValues[0].indexOf('0') === 0 ? strippedValues[0].substring(1) : strippedValues[0]
    const decimal = strippedValues.length > 1 ? '.' : ''
    const cents = strippedValues[1] ? strippedValues[1].substring(0, 2) : ''
    el.value = '$' + dollars + decimal + cents
    el.dispatchEvent(new Event('input'))
    // Add event listener to format value on blur
    el.addEventListener('blur', (event) => {
      const blurStrippedValues = event.target.value.replace(/([^0-9.])+/g, '').split('.')
      const blurDollars = blurStrippedValues[0]
      const blurCents = blurStrippedValues[1]
      if (blurCents !== undefined) {
        // If decimal point, check if we need to fill in 0s
        if (blurDollars !== undefined && blurDollars.length === 0) {
          event.target.value = event.target.value.replace('$', '$0')
        }
        if (blurCents.length < 2) {
          const blurValueZeros = blurCents.length === 0 ? '00' : '0'
          event.target.value = event.target.value + blurValueZeros
        }
        event.target.dispatchEvent(new Event('input'))
      }
    })
  },
  update (el) {
    // Set currency value every update
    // TODO: Figure out a good way to make this a reusable function, bind and update are the same
    const strippedValues = el.value.replace(/([^0-9.])+/g, '').split('.')
    const dollars = strippedValues[0].length > 1 && strippedValues[0].indexOf('0') === 0 ? strippedValues[0].substring(1) : strippedValues[0]
    const decimal = strippedValues.length > 1 ? '.' : ''
    const cents = strippedValues[1] ? strippedValues[1].substring(0, 2) : ''
    el.value = '$' + dollars + decimal + cents
    el.dispatchEvent(new Event('input'))
  }
}
